import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Type, Pagination } from '../models';
import { BaseApiService } from './baseApiService';
import { StorageKey } from './storage.service';

@Injectable({
  providedIn: 'root'
})
export class TypeService extends BaseApiService<Type> {
  get cacheKey(): StorageKey {
    return StorageKey.typeServiceCache;
  }

  getUrl(operation: string, params, id: string = null): string {
    switch (operation) {
      case 'list':
        let regionId = params.regionId;
        if (regionId == null) {
          regionId = 'Brasil';
        }
        return `${environment.apiUrl}/regions/${encodeURIComponent(regionId)}/types`;
      default:
        let url = `${environment.apiUrl}/types`;
        if (id != null) {
          url = url + '/' + encodeURIComponent(id);
        }
        return url;
    }
  }

  list(params: {[params: string]: string}): Promise<Pagination<Type>> {
    return super.list(this.removeContractId(params));
  }

  protected unparse(obj) {
    return Type.unparse(obj);
  }

  protected parse(obj) {
    return Type.parse(obj);
  }

}
